import 'bootstrap-icons/font/bootstrap-icons.css';
import 'animate.css';
import { PlusIcon } from '@heroicons/react/24/outline';
import HighZTooltip from './HighZTooltip';

export default function SentenceHtmlModal({ content, children, allowCopy }) {
  const modalContent = content ? content : children;

  const openSentenceInLeftPanel = () => {
    window.dispatchEvent(
      new CustomEvent('disgenet:open-left-sentence-panel', {
        detail: {
          content: modalContent,
          allowCopy: Boolean(allowCopy),
        },
      }),
    );
  };

  return (
    <>
      <div className="space-x-2 evidence-sentence-legend">
        <HighZTooltip position="left" content="Click to see full sentence">
          <button type="button" onClick={openSentenceInLeftPanel}>
            <PlusIcon className="w-4 h-4 mr-2 text-blue" />
          </button>{' '}
          <span
            onClick={openSentenceInLeftPanel}
            className="cursor-pointer"
            dangerouslySetInnerHTML={{ __html: children }}
          />
        </HighZTooltip>
      </div>
    </>
  );
}
